<template>
  <button
    class="c-mobile-nav-close t-heading-6 j-mobile-nav__close"
    :class="['l-flex','l-flex--align-center']"
    type="button"
    tabindex="2"
    @click="emitClick"
  >
    <span> &#215; </span>
    Close
  </button>
</template>

<script>
export default {
  name: "NavCloseBtn",
  data(){
    return {

    }
  },
  mounted(){

  },
  methods: {
    emitClick(e){
      this.$emit("click", e);
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-mobile-nav-close {
    @include buttonReset;
    span {
      font-size: rem(35px);
      font-weight: 100;
      padding-right: rem(5px);
    }
  }
</style>